import Api from '../Api.js';

const Confirm = function (options) {
    /**
     *  Modal defaults
     */
    let $modal;
    let defaults = {
        ok: Lang.ok,
        cancel: Lang.cancel,
        title: "",
        msg: "",
        confirm: false,
        onClose: function () {
        },
        onConfirm: function () {
        },
        onCancel: function () {
        },
        onValidate: () => true
    };
    $.extend(defaults, options);


    /**
     *  Show the modal
     */
    function show() {
        Api.getTpl('modal')
            .done(r => {

                //Append template
                const tpl = _.template(r);
                $('body').append(tpl({msg: defaults}));

                //Get modal
                $modal = $('.modal').hide();
                defaults.height = $modal.outerHeight();

                // Put modal in place
                $modal.css({
                    top: ($(window).height() / 2) - (defaults.height / 2),
                    left: ($(window).width() / 2) - ($modal.outerWidth() / 2)
                });

                $('.backdrop').fadeTo(200, 0.5, function () {
                    $modal.show();
                    $('.modal-body').find('input:eq(0)').focus();
                });

                //password strength bar for password fields
                $('input[name="password"]').pwstrength({
                    ui: {showVerdictsInsideProgressBar: true}
                });

                setEvents();
            });
    }

    /**
     *  Hide the modal
     */
    function hide() {

        //Get modal
        $modal = $('.modal');

        //Animate
        $modal.animate({
            top: -(defaults.height)
        }, 300, () => {
            $('.backdrop, .modal').fadeTo(200, 0).remove();
        });
    }

    /**
     *  Try validate and close
     */
    function doConfirm() {
        if (defaults.onValidate()) {
            defaults.onConfirm();
            hide();
        }
    }

    /**
     *  Set events
     */
    function setEvents() {
        const $body = $('body');

        //Shortcuts
        $body.off("keyup.smw").on("keyup.smw", (e) => {
            const k = e.keyCode || e.which;
            if (k === 27) {
                defaults.onCancel();
                hide();
            }
        });

        //Close
        $body.off("click.amwc").on("click.amwc", ".modal-close", () => {
            defaults.onClose();
            hide();
        });
        $body.off("closemodal").on("closemodal", () => {
            defaults.onClose();
            hide();
        });

        //Buttons
        $body
            .off('click.confok')
            .on('click.confok', '.modal-foot .btn-primary', () => {
                doConfirm();
            });

        $body
            .off('click.confc')
            .on('click.confc', '.modal-foot .btn-secondary', () => {
                defaults.onCancel();
                hide();
            });

        //Save on enter
        $('.modal:not(.allow-enter)').off("keypress.confk").on("keypress.confk", e => {
            const k = e.keyCode || e.which;
            if (k === 13) {
                doConfirm();
                return false;
            }
        });
    }

    //Finally show the modal
    show();
};

export default Confirm;
